import React, { useState } from "react";
import { Button } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import DraggableField from "../DraggableField/DraggableField";
import {
  closeSelectionsNav,
  openSelectionsNav
} from "./SelectedFieldsPanel.utils";

import {
  DocumentEditorContainer
} from "../../CreateOrEditEditorComponent";

import styles from "../../../../../Reusables/components/ClientApproverSetting/ClientApproverSetting.module.css";

interface SelectedFieldsPanelProps {
  selectionsOpen: boolean;
  setSelectionsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setSignaturesOpen: React.Dispatch<React.SetStateAction<boolean>>;
  selectedFieldsList: { label: string; value: string }[];
  containerRef: React.RefObject<DocumentEditorContainer | null>;
  forwizard?: boolean;
}

const SelectedFieldsPanel: React.FC<SelectedFieldsPanelProps> = ({
  selectionsOpen,
  setSelectionsOpen,
  setSignaturesOpen,
  selectedFieldsList,
  containerRef,
  forwizard,
}) => {
  const [searchText, setSearchText] = useState("");

  const filteredList = selectedFieldsList.filter((obj) =>
    obj.label.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <>
      <div
        className={
          selectionsOpen
            ? "myselections-button-wrapper selections-active"
            : "myselections-button-wrapper"
        }
        style={{ display: forwizard ? "none" : "" }}
      >
        <Button
          className="flex-column-center-center myselections-button"
          onClick={
            !selectionsOpen
              ? () => openSelectionsNav(setSelectionsOpen, setSignaturesOpen, containerRef)
              : () => closeSelectionsNav(setSelectionsOpen)
          }
        >
          <Icon.UiChecks
            style={{
              color: "gray",
              fontSize: 16,
              marginBottom: 0,
            }}
          />
          <p>Selected Fields</p>
        </Button>
      </div>

      <div
        id="myselections"
        className={selectionsOpen ? "myselections fields-section-active" : "myselections"}
        style={{ display: forwizard ? "none" : "" }}
      >
        <div className={styles.dropdownSearchContainer}>
          <Icon.Search className={styles.searchIcon} />
          <input
            type="text"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="Search field..."
            className={styles.dropdownSearch}
          />
        </div>

        <div className="fields-column">
          {filteredList.map((obj, index) => (
            <DraggableField
              key={index}
              label={obj.label}
              value={obj.value}
              type="Selected Field"
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default SelectedFieldsPanel;
